
// Temporary implementation while we decide if this tool will be used or not. Sorry.

export default async (orgId: string) => {
	// @ts-ignore
	window._fs_debug = false;
	// @ts-ignore
	window._fs_host = 'fullstory.com';
	// @ts-ignore
	window._fs_script = 'edge.fullstory.com/s/fs.js';
	// @ts-ignore
	window._fs_org = orgId;
	// @ts-ignore
	window._fs_namespace = 'FS';
	const load = (wind: any, doc: any, namespace: string, tag: any, l: any) => {
		if (namespace in wind) {
			if (wind.console && wind.console.log) {
				wind.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
			}
			return;
		}

		const fs = (a: any, b: any, s?: any) => {
			// @ts-ignore
			fs.q ? fs.q.push([a, b, s]) : fs._api(a, b, s);
		};
		fs.q = [] as any[];
		wind[namespace] = fs;

		let script = doc.createElement(tag);
		script.async = 1;
		script.crossOrigin = 'anonymous';
		// @ts-ignore
		script.src = 'https://' + window._fs_script;

		const fsScript = doc.getElementsByTagName(tag)[0];
		fsScript.parentNode.insertBefore(script, fsScript);

		fs.identify = (i: any, v: any, s: any) => {
			fs(l, { uid: i }, s);
			if (v) fs(l, v, s);
		};

		fs.setUserVars = (v: any, s: any) => {
			fs(l, v, s);
		};

		fs.event = (i: any, v: any, s: any) => {
			fs('event', { n: i, p: v }, s);
		};

		fs.shutdown = () => {
			fs('rec', !1);
		};

		fs.restart = () => {
			fs('rec', !0);
		};

		fs.consent = (a: any) => {
			// @ts-ignore
			fs('consent', !arguments.length || a);
		};

		fs.identifyAccount = (i: any, v: any) => {
			script = 'account';
			v = v || {};
			v.acctId = i;
			fs(script, v);
		};
		fs.clearUserCookie = () => { return; };
	};

	// @ts-ignore
	load(window, document, window._fs_namespace, 'script', 'user');
};
